import React, { useState, useEffect } from 'react'
import gradeSvg from '../../assets/elements/grade.svg'
import ScrollAnimationWrapper from '../helpers/ScrollAnimationWrapper'
import { Container, FeatureContent, FooterContent } from './styles'
import { HeaderTitle } from '../HeaderTitle'
import { PlayVideo } from '../PlayVideo'

import quadraTechImg from '../../assets/quadra-tech.png'
import imgVideo from '../../assets/ART/video-thumb.webp'
import videoModal from '../../assets/videos/art-video.mp4'

export function SectionPraticidade() {
  return (
    <Container>
      <img src={gradeSvg} alt="grade vertical" className="grade-vertical" />

      <HeaderTitle
        title="Praticidade"
        description="Os espaços são pensados para transmitir leveza e harmonia. Feitos para quem gosta de viver com classe e não abre mão da qualidade de vida."
        titleAlign="center"
        descriptionAlign="center"
        fancyText
        fancyTextBgColor="#83C1E9"
      />
      <div className="row row-cols-md-3 justify-content-center">
        <FeatureContent>
          <div className="content">
            <ScrollAnimationWrapper animateIn="animate__fadeInLeft">
              <h3>Suítes ou Studios</h3>
              <h3>68 a 144m²</h3>
            </ScrollAnimationWrapper>
          </div>
        </FeatureContent>
        <FeatureContent isMid={true}>
          <ScrollAnimationWrapper animateIn="animate__fadeInDown">
            <h3 className="gold-item">
              1<span>a</span>3
            </h3>
            <div className="content">
              <h3>Vagas de</h3>
              <h3>Garagem</h3>
            </div>
          </ScrollAnimationWrapper>
        </FeatureContent>

        <FeatureContent>
          <ScrollAnimationWrapper animateIn="animate__fadeInRight">
            <h3 className="gold-item">X</h3>
            <div className="content">
              <h3>Uniplex</h3>
              <h3>144m²</h3>
            </div>
          </ScrollAnimationWrapper>
        </FeatureContent>
      </div>

      <FooterContent>
        <div>
          <h3>Tecnologia com selo</h3>
          <img src={quadraTechImg} alt="Quadra Tech" />
        </div>
        <ScrollAnimationWrapper animateIn="animate__fadeInUp">
          <p>
            Buscamos o que existe de mais moderno para você morar bem. Não é
            apenas automação. É inteligência para oferecer o máximo de
            segurança, facilidade e a qualidade de vida que você merece.
          </p>
        </ScrollAnimationWrapper>
      </FooterContent>

      <br />
      <h2 className="text-gold text-thin text-center mt-5">
        {' '}
        ASSISTA AO VÍDEO E SAIBA MAIS SOBRE O EMPREENDIMENTO{' '}
      </h2>
      <br />

      <PlayVideo
        imagemCapa={imgVideo}
        video={videoModal}
        idModal="videoART"
        textoAlt="Vídeo Quadra ART"
      />
    </Container>
  )
}

